module.exports = __webpack_public_path__ + "assets/gif-preview.gif";


//////////////////
// WEBPACK FOOTER
// ./images/gif-preview.gif
// module id = 314
// module chunks = 0